import { render, staticRenderFns } from "./UserRolePermission.vue?vue&type=template&id=04dd561e&"
import script from "./UserRolePermission.vue?vue&type=script&lang=js&"
export * from "./UserRolePermission.vue?vue&type=script&lang=js&"
import style0 from "./UserRolePermission.vue?vue&type=style&index=0&id=04dd561e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports